import React from 'react';
import { Alert,Button,theme } from 'antd';
import { clientErrorReporter } from '../models/clientErrorReporter';
function Failure({onReload}) {const {token}=theme.useToken();return <div role="region" aria-label="Page display error" style={{minHeight:200,padding:20,background:token.colorBgLayout,color:token.colorText}}><Alert type="error" showIcon message="This page couldn't be displayed." action={<Button onClick={onReload}>Reload</Button>} /></div>;}
export class RouteErrorBoundary extends React.Component {
 state={failed:false};static getDerivedStateFromError(){return {failed:true};}
 componentDidCatch(error,info){clientErrorReporter.report(error,{componentStack:info.componentStack});}
 render(){return this.state.failed ? <Failure onReload={()=>this.setState({failed:false})} />:this.props.children;}
}
